import { gql } from '@apollo/client'
import {
    ManufacturerProductCatalogDetailFragment,
    ManufacturerProductDetailFragments,
    ManufacturerProductSpecDocDetailFragment,
} from '../fragments/productDetail.fragments'

export const GetListingDetail = gql`
    query getListingDetail($input: GetListingDetailInput!) {
        getListingDetail(input: $input) {
            listingId
            properties {
                propertyId
                propertyName
            }
        }
    }
`

export const ListingsGetListingProductTypeProperties = gql`
    query listingsGetListingProductTypeProperties(
        $input: GetListingProductTypePropertiesInput!
    ) {
        listingsGetListingProductTypeProperties(input: $input) {
            properties {
                propertyId
                propertyName
            }
        }
    }
`

const listingMatchDetailFragment = gql`
    fragment listingMatchDetailFragment on ListingMatch {
        listingId
        categories
        displayNameWithFirmName
        firmName
        firmDisplayName
        productName
        productId
        productType
        specAgentProductTypeId
        firmLogoUrl
        sectionName
        type
        submissionStatus
        lastUpdated
        isActive
        firmId
        isDeltekWriterDraft
        images {
            ...imagesFragment
        }
        videos {
            ...videosFragment
        }
        catalogs {
            ...manufacturerProductCatalogDetailFragment
        }
        manufacturerDocs {
            ...manufacturerProductSpecDocDetailFragment
        }
        canAutoGenerateProductSpecification
        familyNumber
        partnershipLinksBIM
        partnershipLinksSwatchbox
        partnershipLinksSM
        partnershipLinksULE
        specAgentProductTypeId
        hasManufacturerOptions
        hasProductDetailNotes
        model
        contentLibrary
    }
    ${ManufacturerProductDetailFragments.imagesFragment}
    ${ManufacturerProductDetailFragments.videosFragment}
    ${ManufacturerProductCatalogDetailFragment}
    ${ManufacturerProductSpecDocDetailFragment}
`

export const ProductSearchQuery = gql`
    query productSearchQuery(
        $manufacturerProductSearchInput: ManufacturerProductSearchInput!
    ) {
        listingSearch(input: $manufacturerProductSearchInput) {
            facets {
                name
                values {
                    value
                }
            }
            matches {
                ...listingMatchDetailFragment
            }
            count
        }
    }
    ${listingMatchDetailFragment}
`

export const ExportListingsCount = gql`
    query productSearchQuery(
        $manufacturerProductSearchInput: ManufacturerProductSearchInput!
    ) {
        listingSearch(input: $manufacturerProductSearchInput) {
            count
        }
    }
`

export const ProductSearchAutosuggestQuery = gql`
    query listingAutoSuggest($input: ManufacturerProductAutoSuggestInput!) {
        listingAutoSuggest(input: $input) {
            result
            searchAfterKey
        }
    }
`

export const ProductListingDetailsAutoSuggestQuery = gql`
    query productListingDetailsAutoSuggest(
        $input: ProductListingDetailsAutoSuggestInput!
    ) {
        productListingDetailsAutoSuggest(input: $input) {
            listingType
            productFamilyDetails {
                sectionNumber
                sectionName
                formattedSectionName
            }
            productTypeDetails {
                sectionNumber
                sectionName
                productType
                formattedProductTypeName
            }
        }
    }
`
export const GetAllProducts = gql`
    query getAllProducts(
        $manufacturerProductSearchInput: ManufacturerProductSearchInput!
    ) {
        listingSearch(input: $manufacturerProductSearchInput) {
            matches {
                productName
                listingId
                firmId
            }
        }
    }
`
